import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProvisioningService } from '../../../services/provisioning/provisioning.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// two modes, one dialog:
// - default: forward a requisition to Operator Admin (the operator raises;
//   admin provisions). A forward reason is required.
// - cancelMode: send a CONFIRMED booking to the admin queue for CANCELLATION.
//   The reason is fixed (TOCANCEL) on the server; only a remark is asked for.
// data = { bookingId, cancelMode? }.
@Component({
  selector: 'app-forward-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, LoaderComponent],
  templateUrl: './forward-dialog.component.html',
  styleUrls: ['./forward-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class ForwardDialogComponent {
  form: FormGroup;
  isLoading: boolean = false;
  // the standard forward reasons (reports group on these); the remark stays free text
  forwardReasons = [
    'Soft Allocation Needs Review',
    'Wrong Allocation, Needs Cancellation',
    'Aged Present, Check for Ground Floor',
  ];

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ForwardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { bookingId: number; cancelMode?: boolean },
    private provisioningService: ProvisioningService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      forwardReason: ['', this.data.cancelMode ? [] : Validators.required],
      forwardRemark: [''],
    });
  }

  get title(): string {
    return this.data.cancelMode
      ? `Send booking #${this.data.bookingId} for cancellation`
      : `Forward booking #${this.data.bookingId} to admin`;
  }

  get submitLabel(): string {
    return this.data.cancelMode ? 'Send for cancellation' : 'Forward';
  }

  submit(): void {
    if (this.form.invalid) {
      this.toastService.error('A forward reason is required.');
      return;
    }
    this.isLoading = true;
    const request$ = this.data.cancelMode
      ? this.provisioningService.forwardCancel(this.data.bookingId, {
          forwardRemark: this.form.value.forwardRemark || undefined,
        })
      : this.provisioningService.forwardToAdmin(this.data.bookingId, this.form.value);
    request$.subscribe({
      next: (res: any) => {
        this.toastService.success(res?.message || 'Forwarded to admin.');
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: (err) => {
        this.isLoading = false;
        this.toastService.error(err?.error?.message || 'Forward failed.');
      },
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
